import script from "./sendAsset.vue?vue&type=script&setup=true&lang=js"
export * from "./sendAsset.vue?vue&type=script&setup=true&lang=js"

import "./sendAsset.vue?vue&type=style&index=0&id=45ecd89e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45ecd89e"]])

export default __exports__